import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import { PurchaseMethodsModel } from 'commons-vehicle/PurchaseMethods/index.js';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25';

import AccessoriesListing from 'commons-vehicle/Quote/components/TransactionSummary/AccessoriesListing/AccessoriesListing.jsx';
import ProtectionsListing from 'commons-vehicle/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx';
import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';
// import AmountLineItemWithIcon from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx';

const CashPurchase = ({ purchaseMethods, quoteV25, currentSection }) => {
    const { cashPurchase, transaction } = quoteV25;
    const sellingPrice = cashPurchase ? cashPurchase.sellingPrice : 0;

    const REVIEW = 1;
    const COMPLETED = 5;

    const displayAmount = () => {
        return (
            <div className="vehicle__detailsPrice">
                <ul className="SidebarSummary__listingAmount">
                    <h3 className="sr-title">{LocaleService.t('SUMMARY.TRANSACTION_TITLE_CASH_PURCHASE')}</h3>
                    {transaction.map((amount) => {
                        return (
                            <div>
                                <AmountLineItem
                                    label={amount.name}
                                    amount={amount.amount}
                                    separator={amount.category === 'total' || amount.category === 'toPay'}
                                    subItem={amount.items}
                                />
                            </div>
                        );
                    })}
                </ul>
            </div>
        );
    };

    const protection = transaction ? transaction.filter((item) => item.category === 'protection') : null;
    const option = transaction ? transaction.filter((item) => item.category === 'option') : null;
    const purchaseMethodLabels = purchaseMethods.getPurchaseMethodLabels(LocaleService);
    const protectionsPackages = purchaseMethods.getSelectedProtectionsPackages();
    const accessoiresOptionsPackages = purchaseMethods.getSelectedOptions();

    const czGroup = 'widget.checkout';
    const cz = ContentZonesService.getContentZone(czGroup, 'sidebar.selling.price.label');

    const sellingPriceLabel = (cz && cz.getValue()) || LocaleService.t('SUMMARY.SELLING_PRICE');

    return (
        <div className="CashPurchaseSummary">
            <div className="vehicle__salePrice">
                <span className="total-price">
                    <AmountLineItem label={sellingPriceLabel} amount={sellingPrice} />
                </span>
            </div>
            <ProtectionsListing
                purchaseMethodLabels={purchaseMethodLabels}
                protectionsPackages={protectionsPackages}
                purchaseMethods={purchaseMethods}
                protection={protection}
            />
            <AccessoriesListing
                accessoriesOptions={accessoiresOptionsPackages}
                purchaseMethods={purchaseMethods}
                option={option}
            />
            {currentSection.value !== REVIEW && currentSection.value !== COMPLETED && displayAmount()}
        </div>
    );
};

CashPurchase.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsModel).isRequired,
    quoteV25: PropTypes.instanceOf(QuoteModelV25).isRequired,
    currentSection: PropTypes.shape({
        value: PropTypes.number.isRequired,
    }).isRequired,
};

CashPurchase.displayName = 'CashPurchase';

export default CashPurchase;
